package app.api

import app.client
import app.model.Deployable
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import kotlinx.coroutines.Job

class DeployablesApi : RootStore<List<Deployable>>(emptyList(), job = Job()) {
    val handler = handle {
        client.get(Routing.Deployables.Name()).body<List<Deployable>>()
    }
}
